import React, { Component } from 'react';
import "../components/header.css";
class Header extends Component {
    // constructor(props) {
    //     super(props);
    // }
    // state = {  }
    render() { 
        return (
            <div>
                <header>
                    <div id='brand'>LOAMINCH</div>
                    <nav>
                        <ul>
                            <li>Home</li>
                            <li>Sermons</li>
                            <li>About</li>
                            
                        </ul>
                    </nav>
                </header>
            </div>
        );
    }
}
 
export default Header;